import secureStorage from '@/utils/secureStorage';

const state = {
    userTranscription: [], // Ovde će se čuvati filtrirane transakcije
    pusher: null // Pusher instanca
};

const mutations = {
    SET_USER_TRANSCRIPTION(state, transcriptions) {
        state.userTranscription = transcriptions;
    },
    SET_PUSHER(state, pusherInstance) {
        state.pusher = pusherInstance;
    }
};

const actions = {
    updateDataFromPusher({ commit }, transcriptions) {
        // Preuzimanje user_id iz localStorage-a
        const userId = secureStorage.getItem('user').id;

        // Filtriranje transakcija
        const filteredTranscriptions = transcriptions.filter(t => t.user_id === userId);

        // Ažuriranje stanja sa filtriranim transakcijama
        commit('SET_USER_TRANSCRIPTION', filteredTranscriptions);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
